angular.module('zc.projects')
  .component('zcCampaignArmsList', {
    templateUrl: '/templates/projects.campaigns/components/campaign_arms_list.html',
    bindings: {
      project: '<',
      campaign: '<',
    },
    controller: CampaignArmsList,
    controllerAs: 'vm'
  });

CampaignArmsList.$inject = ['Apollo'];
function CampaignArmsList(Apollo) {
  const vm = this;

  vm.activeCampaignArms = [];
  vm.isBanditActive = false;
  vm.isDisplayTable = false;
  vm.isLoaded = false;
  vm.timingSettingsURL = `${ZC_CONFIG.AIDEAL_URL}/site/${vm.project.apikey}/campaigns/${vm.campaign.id}/timing`;

  function getCampaignArms() {
    const GET_CAMPAIGN_ARMS = gql(`
      query GetCampaignArms(
        $apikey: String
        $campaignId: ID
        $isActive: Boolean
        $campaignArmsIsActive: Boolean
      ) {
        project(apikey: $apikey) {
          campaign(id: $campaignId) {
            is_bandit_active
            automators(is_active: $isActive) {
              campaignArms(is_active: $campaignArmsIsActive) {
                id
                aiModel {
                  algo
                }
                ratio
                threshold
              }
            }
          }
        }
      }`,
    );

    return Apollo.query(
      GET_CAMPAIGN_ARMS,
      {
        apikey: vm.project.apikey,
        campaignId: vm.campaign.id,
        isActive: true,
        campaignArmsIsActive: true,
      },
    );
  }

  vm.$onInit = () => {
    getCampaignArms()
      .then(res => {
        vm.isBanditActive = _.get(res, 'project.campaign.is_bandit_active', false);
        vm.activeCampaignArms = _.cloneDeep(
          _.flatMap(res.project.campaign.automators, x => x.campaignArms)
        );
        vm.isLoaded = true;
      });
  };
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/components/campaign_arms_list.js